import React, { useCallback, useEffect } from 'react';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import styles from './TransitionCard.module.scss';
import cx from 'classnames';
import { formatSecondsToDuration } from '../../utils/TimeUtil';
import { TRANSITION_TYPE } from '../../constants/editorConst';
import { useTranslation } from 'react-i18next';

const TransitionCard = ({
  transition,
  saving,
  index,
  active,
  isMoving,
  handleTransitionClicked,
  handleDeleteTransition,
  disabled,
  showMinCard,
}) => {
  const { t } = useTranslation();

  const onDeleteTransition = () => {
    handleDeleteTransition(index);
  };

  const handleSelectTransitions = useCallback(() => {
    if (!disabled) {
      handleTransitionClicked(index);
    }
  }, [index, disabled]);

  useEffect(() => {
    console.log('showMinCard', showMinCard);
  }, [showMinCard]);

  return (
    <div
      className={cx(styles.container, {
        [styles.active]: active,
        [styles.isMoving]: isMoving,
        [styles.disabled]: saving || disabled,
        [styles.min]: showMinCard,
      })}
      onClick={handleSelectTransitions}
    >
      <div className={cx(styles.indicationContainer, { [styles.active]: active, [styles.min]: showMinCard })}>
        <CustomButton
          variant="link"
          disabled={!active}
          className={cx(styles.removeBtn, { [styles.visible]: active })}
          onClick={onDeleteTransition}
          ariaLabel={t('general.close')}
        >
          <Icon src="close" className={styles.removeIcon} />
        </CustomButton>
        <Icon
          src="transition"
          className={cx(styles.transitionTypeIcon, {
            [styles.dipToBlack]: transition.type === TRANSITION_TYPE.DIP_TO_BLACK,
          })}
        />
      </div>
      {!showMinCard && <div className={styles.duration}>{formatSecondsToDuration(transition.durationMs / 1000)}</div>}
    </div>
  );
};

export default TransitionCard;
